import React from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';
import { VehicleModelSelect } from '../inputs/vehicle-model-select';
import { OptionOrOptions } from '../option';
import { CommonControlProps, IntegratedFormControl } from './integrated-form-control';

type VehicleModelSelectProps = React.ComponentProps<typeof VehicleModelSelect>;
type Props<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = CommonControlProps<TFieldValues, TName> & {
    vehicleMakeId?: number;
    vehicleModelSelectProps?: VehicleModelSelectProps;
    cRef?: React.Ref<HTMLInputElement>; // 	https://fettblog.eu/typescript-react-generic-forward-refs/
};

export function FormVehicleModelSelect<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>(props: Props<TFieldValues, TName>): React.ReactElement {
    const { vehicleModelSelectProps, vehicleMakeId, ...integratedFormControlProps } = props;
    const renderViewMode = React.useCallback((value: OptionOrOptions) => {
        if (Array.isArray(value)) {
            if (value.length === 0) return '--';
            return value.map((option) => option.label).join(', ');
        }
        return value.label;
    }, []);
    return (
        <IntegratedFormControl {...integratedFormControlProps} renderViewMode={renderViewMode}>
            {(inputProps) => (
                <VehicleModelSelect
                    vehicleMakeId={vehicleMakeId}
                    {...inputProps}
                    {...vehicleModelSelectProps}
                />
            )}
        </IntegratedFormControl>
    );
}
